declare function require(name: string);
/* tslint:disable:no-var-requires no-require-imports*/
const deepEqual = require('deep-equal');

function padStart(value: string, targetLength: number, padString?: string): string {
    padString = String((typeof padString !== 'undefined' ? padString : ' '));
    if (value.length > targetLength) {
        return value;
    } else {
        targetLength = targetLength - value.length;
        if (targetLength > padString.length) {
            padString += padString.repeat(targetLength / padString.length);
        }
        return padString.slice(0, targetLength) + String(value);
    }
}

function flatMap<TInput, TOutput>(array: TInput[], callback: (value: TInput, index: number) => TOutput[]): TOutput[] {
    return array.reduce((acc: TOutput[], next: TInput, index) => {
        acc.push.apply(acc, callback(next, index));
        return acc;
    }, []);
}

function limitedNumber(value: number, limit: number, targetLength: number): { output: string, showPlus: boolean } {
    const ZERO = '0';
    return value > limit ? {
        output: limit.toString(),
        showPlus: true,
    } : {
        output: padStart(value.toString(), targetLength, ZERO),
        showPlus: false
    };
}

//  method formats a number to fixed-point notation ex 9 to 9.00.
function optionalNumberToStringNotation(value, fixedPoint: number) {
    if (typeof (value) === 'number') {
        const d = Math.pow(10, 2);
        const num = (parseInt((value * d).toString(), 10) / d).toFixed(2);
        return num.toString();
    }
    return '';
}

function formatToTwoDigits(value: number): string {
    const obj = limitedNumber(value, 99, 2);
    return obj.showPlus ? `${obj.output}+` : obj.output;
}

const merge = (...sources) => Object.assign({}, ...sources);

const isEqual = (newValue, previousValue) => {
    return deepEqual(newValue, previousValue);
};

const concatNonEmpty = (...values: string[]) =>
    values.length > 0 ? values.filter((item) => !!item).join(' ') : '';

function isUpperCase(str: string): boolean {
    if (str) {
        return str === str.toUpperCase();
    }
    return true;
}
// This function will sentence case excluding the Abbreviation like IPVN will be excluded.
// for example:- if the string is pass as "this is QUIT Simple"
// so here the function first check if there is any word which is in upper case
// if yes then it will skip the word, as here "QUIT" will be skip
// and then there is a check which will sentence case the entire string as here the output will be "This is QUIT simple"
function toSentenceCaseExcludingAbbreviation(data: string): string {
    if (data) {
        const finalString = data
            .trim()
            .split(' ')
            .map((element) => {
                if (!element) {
                    return element;
                }
                return isUpperCase(element) ? element : element.toLowerCase();
            })
            .join(' ');

        return finalString.replace(finalString.charAt(0), finalString[0].toUpperCase());
    }
    return data;
}

export {
    merge,
    flatMap,
    limitedNumber,
    padStart,
    formatToTwoDigits,
    optionalNumberToStringNotation,
    isEqual,
    concatNonEmpty,
    toSentenceCaseExcludingAbbreviation
};
